import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import ShopSettingsService from "../../../services/ShopService";
import { ReactComponent as PaymentIcon } from "../../../images/svg/card.svg";
import toast from "react-hot-toast";
import SkeletonLoading from "../../utils/Loading/SkeletonLoading";

function PaymentMode() {
  const [paymentModes, setPaymentModes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getPaymentModes = async () => {
    setIsLoading(true);
    try {
      const resp = await ShopSettingsService.getPaymentModes();
      setPaymentModes(resp);
    } catch (error) {
      toast.error("Failed to load payment modes");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getPaymentModes();
  }, []);

  return (
    <Grid container className={styles.contentWrapper} mt={0} rowGap={2}>
      <Grid item xs={12} className={styles.dataWrapper}>
        <Grid>
          {isLoading ? (
            <SkeletonLoading isOpen={true} count={2} height={56} xs={12} sm={12} md={12} lg={12} />
          ) : paymentModes.length === 0 && !isLoading ? (
            <p>No payment modes available</p>
          ) : (
            paymentModes.map((mode, index) => (
              <Grid key={index} item xs={12} className={styles.container}>
                <div className={styles.contentSection}>
                  <PaymentIcon className={styles.paymentIcon} />
                  <h4 className={styles.label}>Mode Name :</h4>
                  <h4 className={styles.value}>{mode?.name}</h4>
                </div>
                <div className={styles.divider} />
                <div className={styles.contentSection}>
                  <h5 className={styles.label}>Status </h5>
                  <h4 className={`${styles.value} ${mode?.is_enabled ? styles.activeStatus : styles.inactiveStatus}`}>
                    {mode?.is_enabled ? "Active" : "Inactive"}
                  </h4>
                </div>
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PaymentMode;
